import * as React from 'react';
import { Routes } from 'constants/pages';
import { Navigate } from 'react-router-dom';
import { AddContainers } from './AddContainers';
import { Containers, DeletedContainers } from './Containers';
import { Dashboard } from './Dashboard';
import { HistoricalPerDiem } from './HistoricalPerDiem/HistoricalPerDiem';

export const shipmentsRoutes = () => {
  return [
    {
      path: Routes.ShipmentsReports,
      element: <HistoricalPerDiem />,
    },
    {
      path: Routes.ShipmentsDashboard,
      element: <Dashboard />,
    },
    { path: Routes.ShipmentsAdd, element: <AddContainers /> },
    {
      path: Routes.ShipmentsActive,
      element: <Containers />,
    },
    {
      path: Routes.ShipmentsDeleted,
      element: <DeletedContainers />,
    },
    { path: Routes.Shipments, element: <Navigate to={Routes.ShipmentsActive} /> },
  ];
};
